import React, { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Header from "../../components/Header";
import PageBanner from "../../components/PageBanner";
import Footer from "../../components/Footer";
import { assetUrl } from "../../services/assetUrl";
import "./yuvothsava.css";

/* ========================================================================== */
const yuvothsavaData = {
  banner: { image: "/images/yuvothsava-page/yuvothsava-banner.png" },
  intro: {
    title: "22nd VTU Youth Festival",
    subtitle: "Yuvothsava 2023",
    description:
      "The 22nd VTU Youth Festival, known as Yuvothsava 2023, was held from 29th March 2023 to 1st April 2023 at Nagarjuna College of Engineering and Technology. This grand event brought together 75 colleges from all over Karnataka, with more than 2100+ participants, 200+ accompanists, and 150+ contingent incharges. The festival comprised 25 different events spanning across five categories, including Dance, Music, Theater, Literature, and Fine Arts.",
    image: "/images/yuvothsava-page/intro.png",
  },
  gallery1: [
    "/images/yuvothsava-page/event1.png",
    "/images/yuvothsava-page/event2.png",
    "/images/yuvothsava-page/event3.png",
    "/images/yuvothsava-page/event2.png",
    "/images/yuvothsava-page/event3.png",
    "/images/yuvothsava-page/event1.png",
  ],
  inauguration: {
    text:
      "The festival was inaugurated on 29th March at 10 am in the presence of esteemed dignitaries. The honorable Vice Chancellor of Visvesvaraya Technological University (VTU), Dr. Vidyashankar S, graced the occasion with his motivating words. The Chief Operating Officer of Nagarjuna Education Society, Smt. Bhanu Chaitanya, also participated in the inauguration.",
    sections: [
      {
        title: "Participation",
        content:
          "A total of 75 colleges actively participated in the festival, showcasing their talents and competing in various events. The festival saw the active involvement of more than 2100 participants, demonstrating their skills and creativity. Along with the participants, there were 200 accompanists who added to the performances, and 150 contingent in-charges who managed and coordinated the teams.",
      },
      {
        title: "Event Categories",
        content:
          "The festival comprised a diverse range of events across five categories: Dance, Music, Literature, Fine Arts, and Theater. Each category featured solo and group performances, exhibiting the participants' prowess and enthroning the audience with their artistic skills and imagination.",
      },
    ],
  },
  gallery2: [
    "/images/yuvothsava-page/arts1.png",
    "/images/yuvothsava-page/arts2.png",
    "/images/yuvothsava-page/arts3.png",
    "/images/yuvothsava-page/arts2.png",
    "/images/yuvothsava-page/arts3.png",
    "/images/yuvothsava-page/event1.png",
  ],
  championship: {
    title: "Events & Championship",
    tabs: [
      {
        id: "gala",
        label: "Gala Night",
        description:
          "A special highlight of the festival was the gala night held on 30th March 2023, which featured a thrilling DJ Night. The energetic atmosphere and music brought all the students together for a night of enjoyment and celebration.",
        images: [
          "/images/yuvothsava-page/winrun1.png",
          "/images/yuvothsava-page/winrun2.png",
          "/images/yuvothsava-page/winrun3.png",
          "/images/yuvothsava-page/winrun4.png",
          "/images/yuvothsava-page/winrun5.png",
          "/images/yuvothsava-page/winrun6.png",
        ],
      },
      {
        id: "valedictory",
        label: "Valedictory Event",
        description:
          "The valedictory event took place on 31st March 2023. The esteemed Chief Guest was Dr. T. N. Srinivas, Registrar Evaluation at VTU. Dr. Srinivas addressed the participants, extending his congratulations to all the participants and winners.",
        images: [
          "/images/yuvothsava-page/winrun4.png",
          "/images/yuvothsava-page/winrun5.png",
          "/images/yuvothsava-page/winrun6.png",
          "/images/yuvothsava-page/winrun1.png",
          "/images/yuvothsava-page/winrun2.png",
          "/images/yuvothsava-page/winrun3.png",
        ],
      },
      {
        id: "winners",
        label: "Winners & Championship",
        description:
          "At the valedictory event, the winners of the individual events were announced, and the overall championship of Yuvothsava 2023 was declared. Deserving teams were acknowledged for their outstanding performances.",
        images: [
          "/images/yuvothsava-page/winrun7.png",
          "/images/yuvothsava-page/winrun1.png",
          "/images/yuvothsava-page/winrun5.png",
          "/images/yuvothsava-page/winrun1.png",
          "/images/yuvothsava-page/winrun2.png",
          "/images/yuvothsava-page/winrun3.png",
        ],
      },
    ],
  },
  winners: {
    categories: [
      "Folk Orchestra",
      "Group Song Indian",
      "Group Song Western",
      "Classical Vocal Solo",
      "Western Vocal Solo",
      "Light Vocal Solo",
      "Mime",
      "Mimicry",
      "Quiz",
      "Debate",
      "Elocution",
      "Folk Dance",
      "Overall Championship",
    ],
    data: {
      "Folk Orchestra": [
        { rank: "Winner", name: "Alvas Institute of Engineering and Technology" },
        { rank: "1st Runner Up", name: "Jawaharlal Nehru National College of Engineering" },
        { rank: "2nd Runner Up", name: "BNMIT" },
      ],
      "Group Song Indian": [
        { rank: "Winner", name: "R V College of Engineering" },
        { rank: "1st Runner Up", name: "BNMIT" },
        { rank: "2nd Runner Up", name: "Vivekananda College of Engineering and Technology" },
      ],
      "Overall Championship": [
        { rank: "Winner", name: "BNMIT" },
        { rank: "1st Runner Up", name: "MSRIT" },
        { rank: "2nd Runner Up", name: "JNNCE" },
      ],
    },
  },
};

const STATS = [
  { value: "75", label: "Colleges" },
  { value: "2100+", label: "Participants" },
  { value: "200+", label: "Accompanists" },
  { value: "150+", label: "In-charges" },
  { value: "25", label: "Events" },
  { value: "5", label: "Categories" },
];

/* Only 3 unique images exist per gallery; dedupe so nothing repeats on the page. */
const HIGHLIGHTS = [...new Set(yuvothsavaData.gallery1)];
const PERFORMANCES = [...new Set(yuvothsavaData.gallery2)].filter((s) => s.includes("arts"));

const EASE = [0.22, 1, 0.36, 1];

/* ---------- lightbox icons ---------- */
const lbSvg = { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" };
const IconExpand = (<svg {...lbSvg}><path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M16 21h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" /></svg>);
const IconClose = (<svg {...lbSvg}><path d="M18 6 6 18M6 6l12 12" /></svg>);
const IconPrev = (<svg {...lbSvg}><path d="m15 18-6-6 6-6" /></svg>);
const IconNext = (<svg {...lbSvg}><path d="m9 18 6-6-6-6" /></svg>);

/* ---------- scroll reveal (IntersectionObserver + visibility failsafe) ---------- */
const Reveal = ({ children, className = "", delay = 0, as: Tag = "div" }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const failsafe = setTimeout(() => setShown(true), 1400);
    if (!("IntersectionObserver" in window)) {
      setShown(true);
      return () => clearTimeout(failsafe);
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setShown(true);
            io.disconnect();
            clearTimeout(failsafe);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -6% 0px" }
    );
    io.observe(el);
    return () => {
      io.disconnect();
      clearTimeout(failsafe);
    };
  }, []);
  return (
    <Tag ref={ref} className={`yuv-reveal ${shown ? "is-in" : ""} ${className}`} style={{ transitionDelay: `${delay}ms` }}>
      {children}
    </Tag>
  );
};

const SectionHead = ({ kicker, title, note, center }) => (
  <div className={`yuv-sechead ${center ? "yuv-sechead--center" : ""}`}>
    <span className="yuv-kicker">{kicker}</span>
    <h2 className="yuv-title">{title}</h2>
    {note && <p className="yuv-note">{note}</p>}
  </div>
);

const RANK_NUM = { Winner: "1", "1st Runner Up": "2", "2nd Runner Up": "3" };

const Yuvothsava = () => {
  const [moment, setMoment] = useState(0);
  const [shot, setShot] = useState(0);
  const [cat, setCat] = useState("Folk Orchestra");
  const [lightbox, setLightbox] = useState(null); // { images, index } | null

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Yuvothsava 2023 | NCET";
  }, []);

  const openLightbox = (images, index) => setLightbox({ images, index });
  const closeLightbox = () => setLightbox(null);
  const stepLightbox = (dir) =>
    setLightbox((lb) => (lb ? { ...lb, index: (lb.index + dir + lb.images.length) % lb.images.length } : lb));

  // keyboard controls + body scroll lock while the lightbox is open
  useEffect(() => {
    if (!lightbox) return;
    const onKey = (e) => {
      if (e.key === "Escape") closeLightbox();
      else if (e.key === "ArrowRight") stepLightbox(1);
      else if (e.key === "ArrowLeft") stepLightbox(-1);
    };
    window.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [lightbox]);

  const activeMoment = yuvothsavaData.championship.tabs[moment];
  const heroShot = activeMoment.images[shot] || activeMoment.images[0];
  const results = yuvothsavaData.winners.data[cat];

  const selectMoment = (i) => {
    setMoment(i);
    setShot(0);
  };

  return (
    <div className="yuv">
      <Header parentMenu="events" topbarEnable="enable" />

      <PageBanner
        eyebrow="Cultural Spectacle · Yuvothsava 2023"
        title={yuvothsavaData.intro.title}
        subtitle="Four days of dance, music, theatre, literature and fine arts — VTU's grandest youth festival, hosted at NCET Bengaluru."
      />

      {/* ---------- festival stat ribbon ---------- */}
      <div className="yuv-shell">
        <div className="yuv-ribbon">
          {STATS.map((s, i) => (
            <div className="yuv-ribbon__item" key={i}>
              <span className="yuv-ribbon__value">{s.value}</span>
              <span className="yuv-ribbon__label">{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      <main>
        {/* ================= ABOUT — editorial split ================= */}
        <section className="yuv-section yuv-shell">
          <div className="yuv-about">
            <Reveal className="yuv-about__copy">
              <SectionHead kicker="About the Festival" title="Yuvothsava 2023" />
              <p className="yuv-about__lede">{yuvothsavaData.intro.description}</p>
              <div className="yuv-about__meta">
                <div>
                  <span className="yuv-about__meta-k">Dates</span>
                  <span className="yuv-about__meta-v">29 Mar – 1 Apr 2023</span>
                </div>
                <div>
                  <span className="yuv-about__meta-k">Venue</span>
                  <span className="yuv-about__meta-v">NCET, Bengaluru</span>
                </div>
                <div>
                  <span className="yuv-about__meta-k">Host</span>
                  <span className="yuv-about__meta-v">VTU · 22nd Edition</span>
                </div>
              </div>
            </Reveal>

            <Reveal className="yuv-about__media" delay={80}>
              <div className="yuv-about__frame">
                <img src={assetUrl(yuvothsavaData.intro.image)} alt="Yuvothsava 2023 celebration" loading="lazy" />
              </div>
              <span className="yuv-about__badge">
                <b>4</b> Days of Culture
              </span>
            </Reveal>
          </div>
        </section>

        {/* ================= HIGHLIGHTS — mosaic ================= */}
        <section className="yuv-section yuv-shell">
          <SectionHead kicker="Glimpses" title="Festival Highlights" note="Moments from four days of performances, energy and celebration." center />
          <Reveal className="yuv-trio">
            {HIGHLIGHTS.map((img, i) => (
              <button
                type="button"
                className="yuv-trio__item"
                key={i}
                onClick={() => openLightbox(HIGHLIGHTS, i)}
                aria-label={`View festival highlight ${i + 1} full screen`}
              >
                <img src={assetUrl(img)} alt={`Festival highlight ${i + 1}`} loading="lazy" />
                <span className="yuv-zoom" aria-hidden="true">{IconExpand}</span>
              </button>
            ))}
          </Reveal>
        </section>

        {/* ================= INAUGURATION ================= */}
        <section className="yuv-section yuv-shell">
          <SectionHead kicker="The Beginning" title="Grand Inauguration" center />
          <Reveal className="yuv-quote">
            <span className="yuv-quote__mark" aria-hidden="true">&ldquo;</span>
            <p>{yuvothsavaData.inauguration.text}</p>
          </Reveal>
          <div className="yuv-panels">
            {yuvothsavaData.inauguration.sections.map((sec, i) => (
              <Reveal className="yuv-panel" key={i} delay={i * 80}>
                <span className="yuv-panel__idx" aria-hidden="true">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="yuv-panel__title">{sec.title}</h3>
                <p className="yuv-panel__text">{sec.content}</p>
              </Reveal>
            ))}
          </div>
        </section>

        {/* ================= ART & CULTURE — filmstrip ================= */}
        <section className="yuv-section">
          <div className="yuv-shell">
            <SectionHead kicker="Performances" title="Art & Culture" note="Solo and group performances across dance, music, theatre and fine arts." center />
          </div>
          <Reveal className="yuv-film-wrap">
            <div className="yuv-film">
              {PERFORMANCES.map((img, i) => (
                <figure className="yuv-film__item" key={i}>
                  <img src={assetUrl(img)} alt={`Performance ${i + 1}`} loading="lazy" />
                </figure>
              ))}
            </div>
          </Reveal>
        </section>

        {/* ================= MOMENTS — cinematic viewer ================= */}
        <section className="yuv-section yuv-shell">
          <SectionHead kicker="Highlights" title={yuvothsavaData.championship.title} center />

          <div className="yuv-mseg" role="tablist" aria-label="Festival moments">
            {yuvothsavaData.championship.tabs.map((t, i) => (
              <button
                key={t.id}
                role="tab"
                aria-selected={moment === i}
                className={`yuv-mseg__btn ${moment === i ? "is-active" : ""}`}
                onClick={() => selectMoment(i)}
              >
                {t.label}
              </button>
            ))}
          </div>

          <AnimatePresence mode="wait">
            <motion.div
              key={activeMoment.id}
              className="yuv-stage"
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.32, ease: EASE }}
            >
              <div className="yuv-stage__media">
                <button
                  type="button"
                  className="yuv-stage__hero"
                  onClick={() => openLightbox(activeMoment.images, shot)}
                  aria-label={`View ${activeMoment.label} photo full screen`}
                >
                  <img src={assetUrl(heroShot)} alt={`${activeMoment.label} feature`} />
                  <span className="yuv-zoom yuv-zoom--lg" aria-hidden="true">{IconExpand}</span>
                </button>
                <div className="yuv-stage__thumbs" role="tablist" aria-label={`${activeMoment.label} photos`}>
                  {activeMoment.images.map((img, i) => (
                    <button
                      key={i}
                      className={`yuv-thumb ${shot === i ? "is-active" : ""}`}
                      aria-selected={shot === i}
                      onClick={() => setShot(i)}
                    >
                      <img src={assetUrl(img)} alt={`${activeMoment.label} thumbnail ${i + 1}`} loading="lazy" />
                    </button>
                  ))}
                </div>
              </div>
              <div className="yuv-stage__copy">
                <span className="yuv-stage__label">{activeMoment.label}</span>
                <p className="yuv-stage__desc">{activeMoment.description}</p>
              </div>
            </motion.div>
          </AnimatePresence>
        </section>

        {/* ================= WINNERS — podium explorer ================= */}
        <section className="yuv-section yuv-shell yuv-section--last">
          <SectionHead kicker="Results" title="Winners & Championship" note="Select an event to view the winning contingents of Yuvothsava 2023." center />

          <div className="yuv-winners">
            <div className="yuv-catlist" role="tablist" aria-label="Event categories">
              {yuvothsavaData.winners.categories.map((c, i) => {
                const has = !!yuvothsavaData.winners.data[c];
                return (
                  <button
                    key={i}
                    role="tab"
                    aria-selected={cat === c}
                    className={`yuv-cat ${cat === c ? "is-active" : ""} ${has ? "has-data" : ""}`}
                    onClick={() => setCat(c)}
                  >
                    <span>{c}</span>
                    {has && <span className="yuv-cat__dot" aria-hidden="true" />}
                  </button>
                );
              })}
            </div>

            <Reveal className="yuv-results">
              {results ? (
                <div className="yuv-podium-wrap">
                  <h3 className="yuv-results__title">{cat}</h3>
                  <div className="yuv-podium">
                    {/* DOM order: Winner, 1st, 2nd — CSS reorders to a podium on desktop */}
                    {["Winner", "1st Runner Up", "2nd Runner Up"].map((rk) => {
                      const w = results.find((r) => r.rank === rk);
                      if (!w) return null;
                      const tier = rk === "Winner" ? "gold" : rk === "1st Runner Up" ? "silver" : "bronze";
                      return (
                        <div className={`yuv-pcol yuv-pcol--${tier}`} key={rk}>
                          <div className="yuv-pcard">
                            <span className="yuv-pcard__rank">{rk}</span>
                            <p className="yuv-pcard__name">{w.name}</p>
                          </div>
                          <div className="yuv-ped">
                            <span className="yuv-ped__num">{RANK_NUM[rk]}</span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div className="yuv-empty">
                  <span className="yuv-empty__ic" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4Z" />
                      <path d="M17 5h3a2 2 0 0 1 0 4h-3M7 5H4a2 2 0 0 0 0 4h3" />
                    </svg>
                  </span>
                  <p className="yuv-empty__title">Results archive coming soon</p>
                  <p className="yuv-empty__text">The winners for <b>{cat}</b> haven’t been published to this archive yet.</p>
                </div>
              )}
            </Reveal>
          </div>
        </section>
      </main>

      {/* ================= FULLSCREEN LIGHTBOX ================= */}
      <AnimatePresence>
        {lightbox && (
          <motion.div
            className="yuv-lb"
            role="dialog"
            aria-modal="true"
            aria-label="Photo viewer"
            onClick={closeLightbox}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
          >
            <button type="button" className="yuv-lb__close" onClick={closeLightbox} aria-label="Close viewer">
              {IconClose}
            </button>

            {lightbox.images.length > 1 && (
              <button
                type="button"
                className="yuv-lb__nav yuv-lb__nav--prev"
                onClick={(e) => { e.stopPropagation(); stepLightbox(-1); }}
                aria-label="Previous photo"
              >
                {IconPrev}
              </button>
            )}

            <motion.img
              key={lightbox.index}
              className="yuv-lb__img"
              src={assetUrl(lightbox.images[lightbox.index])}
              alt={`Photo ${lightbox.index + 1} of ${lightbox.images.length}`}
              onClick={(e) => e.stopPropagation()}
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.28, ease: EASE }}
            />

            {lightbox.images.length > 1 && (
              <button
                type="button"
                className="yuv-lb__nav yuv-lb__nav--next"
                onClick={(e) => { e.stopPropagation(); stepLightbox(1); }}
                aria-label="Next photo"
              >
                {IconNext}
              </button>
            )}

            {lightbox.images.length > 1 && (
              <span className="yuv-lb__count">{lightbox.index + 1} / {lightbox.images.length}</span>
            )}
          </motion.div>
        )}
      </AnimatePresence>

      <Footer />
    </div>
  );
};

export default Yuvothsava;
